(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["avatar~index"],{

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var component = {
  name: 'MegAvatar',
  props: {
    size: {
      type: [Number, String],
      validator: function validator(val) {
        if (typeof val === 'string') {
          return ['large', 'medium', 'small'].includes(val);
        }

        return typeof val === 'number';
      }
    },
    shape: {
      type: String,
      default: 'circle',
      validator: function validator(val) {
        return ['circle', 'square'].includes(val);
      }
    },
    icon: String,
    src: String,
    alt: String,
    srcSet: String,
    error: Function,
    fit: {
      type: String,
      default: 'cover'
    }
  },
  data: function data() {
    return {
      isImageExist: true
    };
  },
  computed: {
    avatarClass: function avatarClass() {
      var size = this.size,
          icon = this.icon,
          shape = this.shape;
      var classList = ['meg-avatar'];

      if (size && typeof size === 'string') {
        classList.push("meg-avatar--".concat(size));
      }

      if (icon) {
        classList.push('meg-avatar--icon');
      }

      if (shape) {
        classList.push("meg-avatar--".concat(shape));
      }

      return classList.join(' ');
    }
  },
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  methods: {
    handleError: function handleError() {
      var error = this.error;
      var errorFlag = error ? error() : undefined;

      if (errorFlag !== false) {
        this.isImageExist = false;
      }
    },
    renderAvatar: function renderAvatar() {
      var h = this.$createElement;
      var icon = this.icon,
          src = this.src,
          alt = this.alt,
          isImageExist = this.isImageExist,
          srcSet = this.srcSet,
          fit = this.fit;

      if (isImageExist && src) {
        return h("img", {
          attrs: {
            src: src,
            alt: alt,
            srcSet: srcSet
          },
          on: {
            "error": this.handleError
          },
          style: {
            'object-fit': fit
          }
        });
      }

      if (icon) {
        return h("meg-icon", {
          attrs: {
            name: icon
          }
        });
      }

      return this.$slots.default;
    }
  },
  render: function render() {
    var h = arguments[0];
    var avatarClass = this.avatarClass,
        size = this.size;
    var sizeStyle = typeof size === 'number' ? {
      height: "".concat(size, "px"),
      width: "".concat(size, "px"),
      lineHeight: "".concat(size, "px")
    } : {};
    return h("span", {
      "class": avatarClass,
      style: sizeStyle
    }, [this.renderAvatar()]);
  }
};

component.install = function (Vue) {
  Vue.component(component.name, component);
};

/* harmony default export */ __webpack_exports__["default"] = (component);

/***/ })

}]);